import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copyIcon", "checkmarkIcon", "referralLink"];

  copy() {
    const referralLink = this.referralLinkTarget.innerText;
    navigator.clipboard.writeText(referralLink).then(() => {
      this.copyIconTarget.classList.add("hidden");
      this.checkmarkIconTarget.classList.remove("hidden");

      setTimeout(() => {
        this.checkmarkIconTarget.classList.add("hidden");
        this.copyIconTarget.classList.remove("hidden");
      }, 2000);
    });
  }
}
